var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "container",
      staticClass: "expandable-hover-card loading",
      on: { mouseover: _vm.expand, mouseleave: _vm.collapse }
    },
    [
      _c(
        "div",
        {
          ref: "cardEl",
          staticClass: "card-content",
          class: _vm.card.background_color
        },
        [
          _c("div", { staticClass: "inner" }, [
            _vm.card.top_title
              ? _c("div", {
                  staticClass: "top-title",
                  domProps: { innerHTML: _vm._s(_vm.card.top_title) }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.card.title
              ? _c("h2", {
                  staticClass: "title",
                  domProps: { innerHTML: _vm._s(_vm.card.title) }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.card.show_hover_content
              ? _c(
                  "div",
                  { ref: "hoverCopyEl", staticClass: "hover-content" },
                  [
                    _vm.hoverContent.copy
                      ? _c("div", {
                          staticClass: "copy",
                          domProps: { innerHTML: _vm._s(_vm.hoverContent.copy) }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hoverContent.button
                      ? _c("a", {
                          staticClass: "hover-button",
                          attrs: {
                            href: _vm.hoverContent.button.url,
                            target: _vm.hoverContent.button.target
                          },
                          domProps: {
                            innerHTML: _vm._s(_vm.hoverContent.button.title)
                          }
                        })
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "hover-invite" }, [
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(_vm.hoverContent.hover_invite_text)
                }
              }),
              _vm._v(" "),
              _c("i", { staticClass: "fas fa-plus tx-orange" })
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }